import type { FormControl } from "@/interfaces/form";
import { getNestedProps } from "@/utils";

interface UseInputArgs<T extends boolean = false> {
  control: FormControl;
  field: string;
  /**
   * Se true, registra o campo no formulário e retorna o objeto registration.
   * Use apenas quando o componente precisa conectar o registration a um input.
   * @default false
   */
  shouldRegister?: T;
}

type UseInputReturn<T extends boolean> = {
  errorMessage: string | undefined;
  registration: T extends true ? ReturnType<FormControl["register"]> : undefined;
};

export const useInput = <T extends boolean = false>({
  control,
  field,
  shouldRegister = false as T,
}: UseInputArgs<T>): UseInputReturn<T> => {
  const errorMessage = getNestedProps(control.errors, field)?.message;
  const registration = shouldRegister ? control.register(field) : undefined;

  return {
    errorMessage,
    registration,
  } as UseInputReturn<T>;
};
